import { Component, Input, OnInit } from '@angular/core';
import { PanelInfoBarComponent } from 'components/layout/panel-info-bar/panel-info-bar.component';
import { CommunicationLogComponent } from 'components/task/taskflow/communication-log.component';
import { CommunicationLogEntryModel } from 'models/generated/Communication.Api.Models.CommunicationLogEntry';
import { TaskflowModel } from 'models/generated/Entities.GormCrm.Taskflow';
import { InfoBarIconModel, InfoBarModel } from 'models/InfoBar';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserService } from 'services/user.service';

@Component({
	selector: 'closed-salesflow',
	templateUrl: './closed-salesflow.component.html',
	styles: ['.log-container { padding-left: 23px; }'],
	imports: [PanelInfoBarComponent, CommunicationLogComponent]
})
export class ClosedSalesflowComponent implements OnInit {

	@Input() taskflow?: TaskflowModel;
	expanded = false;
	taskflowCommunicationLogs?: CommunicationLogEntryModel[];
	public infoData: InfoBarModel[] = [];

	constructor(
		private readonly userService: UserService,
		private readonly translate: TranslatePipe,
		private readonly customDate: CustomDatePipe) {
	}

	ngOnInit() {
		if (this.taskflow) {
			this.taskflowCommunicationLogs = this.getAllCommunicationLogsOnTaskflow(this.taskflow);

			this.infoData = [];
			if (this.taskflowCommunicationLogs[0]) {
				let info = new InfoBarModel();
				info.icon = new InfoBarIconModel();
				info.icon.class = this.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right';
				info.icon.color = '#24c8d7';
				info.text = this.translate.transform(this.taskflowCommunicationLogs[0] && this.taskflowCommunicationLogs[0].statusType ?
					'communicationlog.status.' + this.taskflowCommunicationLogs[0].statusType :
					'general.na');
				info.columnWidth = 2;
				this.infoData.push(info);

				info = new InfoBarModel();
				info.icon = new InfoBarIconModel();
				info.icon.class = 'far fa-calendar-alt';
				info.text = String(this.customDate.transform(this.taskflowCommunicationLogs[0].timestamp));
				info.columnWidth = 2;
				this.infoData.push(info);

				info = new InfoBarModel();
				info.icon = new InfoBarIconModel();
				info.icon.class = 'fas fa-user-circle';
				let user = this.userService.user(this.taskflowCommunicationLogs[0].userId);
				info.text = user ? user.name : this.translate.transform('general.na');
				info.columnWidth = 3;
				this.infoData.push(info);

				info = new InfoBarModel();
				info.icon = new InfoBarIconModel();
				info.icon.class = 'fas fa-file-alt';
				info.text = this.taskflowCommunicationLogs[0] ? this.taskflowCommunicationLogs[0].comment : this.translate.transform('general.na');
				info.columnWidth = 5;
				this.infoData.push(info);
			}
		}
	}

	toggleExpand() {
		this.expanded = !this.expanded;
		const chevronIcon = this.infoData[0].icon;
		if (chevronIcon)
			chevronIcon.class = this.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right';
	}
	
	private getAllCommunicationLogsOnTaskflow(taskflow: TaskflowModel): CommunicationLogEntryModel[] {
		let communicationLog: CommunicationLogEntryModel[] = [];

		for (let taskAction of taskflow.taskActions) {
			communicationLog = communicationLog.concat(taskAction.communicationLogEntries);
		}
		communicationLog.sort((a, b) => (b.timestamp ? new Date(b.timestamp).getTime() : new Date(0).getTime()) - (a.timestamp ? new Date(a.timestamp).getTime() : new Date(0).getTime()));
		return communicationLog;
	}
}
